<div class="menu-container dx-card">
  <dx-tooltip>
    <div *dxTemplate="let data = data of 'content'">
      <span>{{tooltipContent}}</span>
    </div>
  </dx-tooltip>
  <dx-tree-view
    [visible]="!noRole"
    [disabled]="SharedSvc.disableSideMenu"
    [items]="items"
    keyExpr="path"
    selectionMode="single"
    [focusStateEnabled]="true"
    expandEvent="click"
    (onItemClick)="onItemClick($event)"
    (onContentReady)="onContentReady($event)"
    width="100%">
  </dx-tree-view>
</div>
